<template>
  <Dialog ref="dialog"
          width="50%"
          icon="fas fa-box"
          @confirm="verify"
          :show-confirm="countSocToLoad < 1"
          title="Cargar subordenes">
    <div v-if="countSocToLoad < 1">
      <el-input type="textarea"
                id="container"
                :rows="3"
                placeholder="124005957777, 124005958888 ..."
                v-model="textareaSocs">
      </el-input>
      <div class="switch-with-splits">
        <el-switch v-model="withSplits"/>
        <span :class="colorSwitch">CONSIDERAR SPLITS</span>
      </div>
      <div class="verify-version-option">
        <el-checkbox v-model="useVerifyV2">
          USAR ENDPOINT DE VERIFICACIÓN V2
        </el-checkbox>
        <span class="verify-version-help">/v1/planning/suborders/verify/v2</span>
      </div>
    </div>
    <div v-else class="progress">
      <p class="indicator">
        <span>total a verificar: </span>{{ countSocToLoad }}
      </p>
      <el-progress :color="color"
                   :text-inside="true"
                   :stroke-width="20"
                   :percentage="loadPercentage"/>
      <p class="indicators">
        <i :class="loadIcon"/> {{ msgLoad }}
        <span class="in-load">
            verificadas: <span class="verified">{{countVerified}}</span> /
            no encontradas: <span class= "not-found">{{countNotFound}}</span> /
            con splits: <span class="split">{{countSplits}}</span>
          </span>
      </p>
    </div>
  </Dialog>
</template>

<script>
import Dialog from '../../base/Dialog.vue';
import { apiRequest } from '../../../../backend/vue-axios/axios';

export default {
  name: 'SuborderAdd',
  components: {
    Dialog,
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    sectors: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      msgLoad: 'Procesando . . .',
      withSplits: false,
      useVerifyV2: false,
      countSocToLoad: 0,
      countCurrentSocLoad: 0,
      countVerified: 0,
      countNotFound: 0,
      countSplits: 0,
      maxPerBatch: 500,
      list: this.value,
      textareaSocs: '',
      color: '#AAD500',
    };
  },
  watch: {
    list() {
      this.$emit('input', this.list);
    },
    value() {
      this.list = this.value;
    },
    countCurrentSocLoad(value) {
      this.msgLoad = `Solicitando verificación: ${value} de ${this.countSocToLoad}`;
      if (value === this.countSocToLoad) this.$refs.dialog.loading(false);
      if (this.loadPercentage === 100) this.msgLoad = 'Verificación finalizada';
    },
  },
  filters: {
    len(data) {
      return data.length;
    },
  },
  methods: {
    open() {
      this.msgLoad = 'Procesando . . .';
      this.countSocToLoad = 0;
      this.countCurrentSocLoad = 0;
      this.countVerified = 0;
      this.countNotFound = 0;
      this.countSplits = 0;
      this.$refs.dialog.visible(true);
    },
    verify() {
      const newSocs = this.clearInput(this.textareaSocs)
        .filter(ns => !this.list.map(s => s.suborder).includes(ns));
      this.list = newSocs
        .map(s => ({
          suborder: s,
          verified: false,
          sectors: [],
          loadedWithVerifyV2: this.useVerifyV2,
        }))
        .concat(this.list);
      this.loadOnlySocs(newSocs);
      this.textareaSocs = '';
    },
    clearInput(textInput) {
      return [...new Set(textInput.trim()
        .split(/\s*[,\n\r][\s\n\r]*/gimu)
        .filter(s => s.match(/^[0-9]{6,20}$/gim))
        .map(s => parseInt(s, 10)))];
    },
    loadOnlySocs(newSocs) {
      if (newSocs.length > 0) {
        const partialNewSocs = [];
        this.countSocToLoad = newSocs.length;
        while (newSocs.length) partialNewSocs.push(newSocs.splice(0, this.maxPerBatch));
        this.loadBatch(partialNewSocs, 5000);
      } else {
        this.$refs.dialog.loading(false);
        this.$notify({
          type: 'warning',
          title: 'Error al cargas las subordenes',
          message: 'No son válidas o están repetidas',
        });
      }
    },
    loadBatch(batch, delay) {
      const newBatch = batch.splice(0, 2);
      newBatch.forEach(async (request) => {
        await this.verifyPartial(request).then(async (socs) => {
          await this.loadPercent(socs);
        });
      });
      if (batch.length > 0) {
        setTimeout(() => { this.loadBatch(batch, delay - (delay / 10)); }, delay);
      }
    },
    loadPercent(socs) {
      const totalNotFound = socs.filter(s => this.notFound(s)).length;
      this.countVerified += socs.length - totalNotFound;
      this.countNotFound += totalNotFound;
      this.countSplits += socs.filter(s => s.splits).length;
      const progress = [];
      while (socs.length) progress.push(socs.splice(0, 50).length);
      for (let i = 0; i < progress.length; i += 1) {
        setTimeout(() => { this.countCurrentSocLoad += progress[i]; }, 25);
      }
    },
    verifyPartial(partialNewSocs) {
      return new Promise((resolve) => {
        apiRequest({
          module: 'planning',
          service: this.useVerifyV2 ? 'verify_suborders_v2' : 'verify_suborders',
          params: {
            suborders: partialNewSocs,
            with_splits: this.withSplits,
          },
        }).then((response) => {
          resolve(response.data);
          response.data.forEach((val) => {
            Object.entries(val).forEach(([k, v]) => {
              this.list.find(s => s.suborder === val.suborder)[k] = v;
            });
            this.list.find(s => s.suborder === val.suborder).verified = true;
            if (val.last_state === -1 && val.current_do !== -1) {
              this.list.find(s => s.suborder === val.suborder).last_state = 1;
              this.list.find(s => s.suborder === val.suborder).last_state_name = 'Digitado';
            }
            this.list.find(s => s.suborder === val.suborder).sectors = this.sectors
              .filter((sector) => {
                const suborder = this.list.find(s => s.suborder === val.suborder);
                return (sector.packageTypes.map(l => l.id).includes(suborder.package_type_id)
                  || (sector.packageTypes.length > 0 && suborder.package_type_name === 'NF'))
                  && sector.localities.map(l => l.id).includes(suborder.locality_id)
                  && !(suborder.splits || [5, 6].includes(suborder.last_state));
              });
          });
        }).catch(() => {
          this.countNotFound += partialNewSocs.length;
          this.countCurrentSocLoad += partialNewSocs.length;
          this.list = this.list.filter(s => !partialNewSocs.includes(s.suborder));
          this.$notify({
            type: 'error',
            title: 'Error al cargas las subordenes',
            message: 'Vuelva a intentarlo más tardes',
          });
        });
      });
    },
    notFound(soc) {
      return soc.current_do === -1;
    },
  },
  computed: {
    loadPercentage() {
      return this.countSocToLoad > 0
        ? Math.round((this.countCurrentSocLoad / this.countSocToLoad) * 100) : 0;
    },
    colorSwitch() {
      return this.withSplits ? '' : 'disable-color';
    },
    loadIcon() {
      return this.loadPercentage === 100 ? 'el-icon-folder-checked' : 'el-icon-loading';
    },
  },
};
</script>

<style lang="scss" scoped>
  .switch-with-splits {
    height: 20px;
    margin: 10px 0;
    span {
      margin: 0 8px;
      line-height: 1.4;
    }
    span, .el-switch { float: right; }
    .disable-color { color: $fb-grey-light-92; }
  }
  .verify-version-option {
    border-top: 1px solid $fb-grey-light-92;
    margin-top: 12px;
    padding-top: 12px;
    .verify-version-help {
      color: $fb-grey;
      display: block;
      font-size: 11px;
      margin: 5px 0 0 24px;
    }
  }
  .loading {
    text-align: center;
    .el-icon-loading {
      font-size: 32px;
      color: $fb-green;
    }
  }
  .progress {
    margin: 14px;
    .indicators {
      height: 18px;
      font-size: 13px;
      margin: 4px 2px;
      font-weight: 300;
      text-transform: lowercase;
      i {
        color: $fb-green;
        font-weight: 900;
        margin-right: 3px;
      }
      .in-load {
        float: right;
        .split { color: $fb-amber; }
        .verified { color: $fb-blue; }
        .not-found { color: $fb-red; }
        .split, .verified, .not-found { font-weight: 600; }
      }
    }
    .indicator {
      font-size: 13px;
      font-weight: 600;
      margin: 0 0 4px 3px;
      span { font-weight: 300; }
      text-transform: lowercase;
    }
  }
</style>
